import { render, staticRenderFns } from "./MultivariateDetection.vue?vue&type=template&id=7884bd0e&scoped=true&"
import script from "./MultivariateDetection.script.js?vue&type=script&lang=js&"
export * from "./MultivariateDetection.script.js?vue&type=script&lang=js&"
import style0 from "./MultivariateDetection.scss?vue&type=style&index=0&id=7884bd0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884bd0e",
  null
  
)

export default component.exports